import { IGetLicenseInfoProps } from 'shared/api/business/interfaces/get-license-info.props.interface';
import { LicenseEnum } from 'shared/types';

export interface ILicenseCalcAmountResult {
  totalPrice: number;
  totalDiscount: number;

  diffPriceNewEmpl: number;
  diffPriceCurrentEmpl: number;
  totalDiffPriceEmpl: number;

  monthlyEmployeePrice: number;
  monthlyEmployeeDiscPrice: number;
  monthlyTotalPrice: number;
  monthlyTotalDiscPrice: number;
}
function getNearestPrice(
  prices: Record<number, number>,
  count: number
): number {
  const keys = Object.keys(prices)
    .map(Number)
    .sort((a, b) => a - b);
  for (let i = keys.length - 1; i >= 0; i--) {
    if (keys[i] <= count) return prices[keys[i]];
  }
  return keys.length ? prices[keys[0]] : 0;
}

export function licenseCalcAmount(
  licType: LicenseEnum,
  License: IGetLicenseInfoProps,
  fromEmplCount: number,
  toEmplCount: number,
  monthCount: number,
  diffDays: number
): ILicenseCalcAmountResult {
  const licEmployeePrice = getNearestPrice(License.employeePrices, toEmplCount);
  const licFromEmployeePrice = getNearestPrice(
    License.employeePrices,
    fromEmplCount
  );
  const emplDiff = toEmplCount - fromEmplCount;

  const result: ILicenseCalcAmountResult = {
    totalPrice: 0,
    totalDiscount: 0,

    diffPriceNewEmpl: 0,
    diffPriceCurrentEmpl: 0,
    totalDiffPriceEmpl: 0,

    monthlyEmployeePrice: licEmployeePrice,
    monthlyEmployeeDiscPrice: 0,
    monthlyTotalPrice: licEmployeePrice * toEmplCount,
    monthlyTotalDiscPrice: 0,
  };
  if (diffDays < 0) {
    diffDays = 0;
  }
  if (!monthCount) {
    result.diffPriceNewEmpl = emplDiff * (licEmployeePrice / 30) * diffDays;
    result.diffPriceCurrentEmpl =
      fromEmplCount *
      ((licEmployeePrice - licFromEmployeePrice) / 30) *
      diffDays;
    result.totalDiffPriceEmpl =
      result.diffPriceNewEmpl + result.diffPriceCurrentEmpl;
    result.totalPrice = result.diffPriceNewEmpl + result.diffPriceCurrentEmpl;
  } else {
    const monthDiscount = License.monthSale[monthCount] ?? 0;
    const licMonthSale = (100 - monthDiscount) / 100;
    result.totalDiscount = monthDiscount;
    result.monthlyEmployeeDiscPrice = licEmployeePrice * licMonthSale;
    result.monthlyTotalDiscPrice =
      licEmployeePrice * licMonthSale * toEmplCount;

    if (licType == LicenseEnum.FREE) {
      result.diffPriceNewEmpl = emplDiff * (licEmployeePrice / 30) * diffDays;
      result.diffPriceCurrentEmpl =
        fromEmplCount *
        ((licEmployeePrice - licFromEmployeePrice) / 30) *
        diffDays;
      result.totalDiffPriceEmpl =
        result.diffPriceNewEmpl + result.diffPriceCurrentEmpl;
      result.totalPrice =
        result.monthlyTotalDiscPrice * monthCount + result.totalDiffPriceEmpl;
    } else if (emplDiff < 0) {
      result.totalPrice = result.monthlyTotalDiscPrice * monthCount;
      result.diffPriceNewEmpl = 0;
      result.diffPriceCurrentEmpl = 0;
      result.totalDiffPriceEmpl = 0;
    } else {
      result.diffPriceNewEmpl = emplDiff * (licEmployeePrice / 30) * diffDays;
      result.diffPriceCurrentEmpl =
        fromEmplCount *
        ((licEmployeePrice - licFromEmployeePrice) / 30) *
        diffDays;
      result.totalDiffPriceEmpl =
        result.diffPriceNewEmpl + result.diffPriceCurrentEmpl;
      result.totalPrice =
        result.monthlyTotalDiscPrice * monthCount + result.totalDiffPriceEmpl;
    }
  }

  (Object.keys(result) as Array<keyof ILicenseCalcAmountResult>).forEach(
    (key) => {
      const value = result[key];
      if (typeof value === 'number') {
        result[key] = Math.round(value * 100) / 100;
      }
    }
  );

  return result;
}
